import {Stack, Typography} from "@mui/material";
import EmptySearchResults from "components/EmptySearchResults";
import {Entity} from "enums/entity";
import React from "react";
import {enAssetLabel} from "constants/index";
import {InProgress} from "components/index";
import EmptyAssets from "components/AssetView/EmptyAssets";

interface PageFooterProps {
  canView: boolean;
  isEmpty: boolean;
  isSearchEmpty: boolean;
  isLoading: boolean;
  atBottom: boolean;
}

function PageFooter(props: PageFooterProps) {
  const {isEmpty, isSearchEmpty, isLoading, atBottom} = props;

  if (isEmpty) {
    return (
      <Stack justifyContent="center" height="40vh" paddingRight={'20%'}>
        <EmptyAssets canView={props.canView}/>
      </Stack>
    )
  }

  if (isSearchEmpty) {
    return (
      <Stack justifyContent="center" height="40vh" paddingRight={'20%'}>
        <EmptySearchResults
          entity={Entity.Asset}
          sx={{minHeight: "100%", marginTop: "0"}}
        />
      </Stack>
    )
  }

  if (atBottom) {
    return (
      <div
        style={{
          paddingRight: '20%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Typography variant="body" textAlign="center" color="text.secondary" paddingY={1}>
          {enAssetLabel.noMoreAssets}
        </Typography>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div
        style={{
          paddingRight: '20%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <InProgress/>
      </div>
    )
  }

  return <div style={{height: 50}}/>;
}

export default PageFooter;